import { Injectable } from '@angular/core';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { ConfigService } from './config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {

  private siteKey: string = "";
  private observ: Observable<string>;

  constructor(
    public configService: ConfigService,
    private reCaptchaV3Service: ReCaptchaV3Service) {

    this.siteKey = this.configService.getConfiguration().captchaV3SiteKey;

  }

  executeRecaptcha(action: string) {

    //console.log(`executeRecaptcha action: ${action}, siteKey: ${this.siteKey}`);

    return new Observable<string>((observer) => {

      this.reCaptchaV3Service.execute(this.siteKey, action, (token) => {

        //console.log(`executeRecaptcha token: ${token}`);

        observer.next(token); // Emit the token

        observer.complete(); // Complete the observable stream

      });

    });

  }
}